<template>
    <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
        <!-- Indicators -->
        <ol class="carousel-indicators">
            <li data-target="#carousel-example-generic" :data-slide-to="index" :class="index == 0 ? 'active' : ''" v-for="(item,index) in list" :key="index"></li>
        </ol>

        <!-- Wrapper for slides -->
        <div class="carousel-inner" role="listbox">
            <div class="item" :class="index == 0 ? 'active' : ''" v-for="(item,index) in list" :key="index">
                <img :src="item">
                <!-- <div class="carousel-caption">
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            list:{
                // default:[
                //     'http://v1.cdn-static.cn/2019/7/28/27809_jymyo1ss.jpg?imageView2/2/w/2000/q/100',
                //     'http://v1.cdn-static.cn/2019/7/28/27809_jymyo1ss.jpg?imageView2/2/w/2000/q/100',
                //     'http://v1.cdn-static.cn/2019/7/28/27809_jymyo1ss.jpg?imageView2/2/w/2000/q/100',
                //     'http://v1.cdn-static.cn/2019/7/28/27809_jymyo1ss.jpg?imageView2/2/w/2000/q/100'
                // ]
            }
        },
        data(){
            return {
                
            }
        }
    }
</script>

<style lang="less" scope>
    .carousel-indicators{
        li{
            margin: 0 5px;
        }
    }
    .item{
        img{
            width: 100%;
            max-height: 80vh;
        }
    }
</style>